import React from 'react';
import { Navigate } from 'react-router-dom';
import { GuardProps } from '@quantum/tools/guard';
import { PageModel } from '../../../../assembler-server/types/PageModel';

interface ProtectedRouteProps {
  path: string;
  guardProps?: GuardProps;
  children?: React.ReactNode;
  pageModel: PageModel;
}

const exceptionPaths = new Set(['/error', '/404', '/maintenance']);

export const ProtectedRoute = ({ path, children, guardProps, pageModel }: ProtectedRouteProps) => {
  if (typeof window !== 'undefined') {
    const previousTemplateName = window.assemblerSelectedTemplate;
    const currentTemplateName = pageModel.templateSelected || undefined;
    if (currentTemplateName !== previousTemplateName) {
      window.location.reload();
    }
  }

  if (guardProps?.evaluate && !exceptionPaths.has(path)) {
    const redirectPath = guardProps.evaluate(path, guardProps.data);
    if (typeof redirectPath === 'string') {
      return <Navigate to={redirectPath} />;
    }
  }
  return children;
};
